export default categories =>
  categories &&
  categories.map(c => {
    const category = c.data.data;
    return { label: category.category_name, value: category.category_value };
  });
